import { Injectable } from '@angular/core';
import { APIService } from '../api.service';
import { Constants } from 'src/app/shared/constants';

@Injectable({
  providedIn: 'root'
})
export class G3msService {

  constructor(private _APIService: APIService) { }

  // callBackElevatorForAvaya(callBackObj:any) {
  //   return this._APIService.post(callBackObj, Constants.G3MS_URLS.callbackFromElevatorForAvaya );
  // }
  callBackElevator(callBackObj:any) {
    const callBackElevator=Constants.G3MS_URLS.callBackElevator + '?country=' +callBackObj.countryShortName + '&elevatorId=' +  callBackObj.elevatorId ;
    return this._APIService.post(callBackObj, callBackElevator);
  }
}
